import { Dispatch } from "redux";
import { setScreenName } from "../../actions/ui";
import dispatch from "../../middleware";

export default function getEffect(screenName: string, storeDispatch: Dispatch) {
  return () => {
    dispatch(storeDispatch, setScreenName(screenName));
    return () => {
      dispatch(storeDispatch, setScreenName(""));
    };
  };
}
